import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["contentIds", "audience", "teams"];
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import { getCommonTeams } from '../utils';
import OwningTeamField from '.';
export function PlaylistOwningTeamField(_ref) {
  var _ref$contentIds = _ref.contentIds,
    contentIds = _ref$contentIds === void 0 ? [] : _ref$contentIds,
    audience = _ref.audience,
    teams = _ref.teams,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var isMultiSelect = (contentIds === null || contentIds === void 0 ? void 0 : contentIds.length) > 1;
  var commonTeams = isMultiSelect ? getCommonTeams(teams.filter(function (team) {
    return team.length > 0;
  })) : teams[0];
  var selectableTeamIds = [];
  if (audience === 'all') {
    selectableTeamIds = undefined; // All available teams in the hub can be selected as potential owners
  } else if (audience === 'teams' || audience === 'mixed') {
    selectableTeamIds = commonTeams === null || commonTeams === void 0 ? void 0 : commonTeams.filter(function (team) {
      return !(team !== null && team !== void 0 && team.isCalculated);
    }).map(function (team) {
      return team.id;
    });
  }
  return /*#__PURE__*/React.createElement(OwningTeamField, _extends({
    contentType: "playlist",
    selectableTeamIds: selectableTeamIds,
    contentIds: contentIds
  }, otherProps));
}
export default PlaylistOwningTeamField;